// extracted by mini-css-extract-plugin
export default {"advertSearchLink":"oDh7gjft","advertSearchIcon":"J8C8lOTH"};